import React, { useEffect, useRef, useState } from 'react'
import "./TeamCards.css"
import { useNavigate } from 'react-router-dom'

function TeamCards({
    title="",
    cardData
}) {

    const navigate = useNavigate()
    const cardRef = useRef()
    const [boxHeight,setBoxHeight] = useState("180px")
    useEffect(()=>{
        const recalcHeight = ()=>{
          setBoxHeight(`${cardRef.current?.offsetWidth}px`)
        }

        recalcHeight()

        window.addEventListener("resize", recalcHeight);
        return () => window.removeEventListener("resize", recalcHeight);
      },[])

  return (
    <div className='TeamCards-container standard-padding-space'>
        <div className='container'>
            <div className='main-title'>
                {title && <h5 className='color-blue mb-4' style={{fontSize:"1.8rem",fontWeight:"700"}}>{title}</h5>}
            </div>
            <div className='row gy-4'>
                 {
                    cardData.map((ele)=>{
                        return(
                            <div className='col-lg-4'>
                                <div className='team-card p-2' onClick={()=>{navigate(`/team-individual/${ele?.id}`)}}>
                                    <img src={ele?.img} className='img-fluid mb-3 w-100' alt='team member' style={{borderRadius:"20px",height:`${boxHeight}`,width:"100%"}} ref={cardRef}/>
                                    <div className='ps-1'>
                                        <h3 className='sub-heading mb-4' style={{fontWeight:`bolder`,fontSize:`1.1rem`}}>{ele?.name}</h3>
                                        <p className='mb-1' style={{color:"grey"}}>{ele?.rank}</p>
                                        <p className='body-paragraph mt-1 mb-0'>{ele?.para}</p>
                                        <button className={`genral-btn-white color-blue ps-1 pt-1`} style={{fontWeight:"800"}} onClick={()=>{navigate(`/team-individual/${ele?.id}`)}}>Learn more →</button>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    </div>
  )
}

export default TeamCards